"use strict";

var __importDefault = function __importDefault(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  },
  react_1 = (Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.SlideInfo = void 0, __importDefault(require("react"))),
  types_1 = require("../types"),
  utils_1 = require("../utils"),
  SlideInfo = function SlideInfo(e) {
    var t = e.activeIndex,
      s = e.itemsCount,
      e = e.renderSlideInfo,
      t = (0, utils_1.getSlideInfo)(t, s).item;
    return "function" == typeof e ? react_1.default.createElement("div", {
      className: types_1.Classnames.SLIDE_INFO
    }, e({
      item: t,
      itemsCount: s
    })) : (e = (0, utils_1.concatClassnames)(types_1.Classnames.SLIDE_INFO_ITEM, types_1.Modifiers.SEPARATOR), react_1.default.createElement("div", {
      className: types_1.Classnames.SLIDE_INFO
    }, react_1.default.createElement("span", {
      className: types_1.Classnames.SLIDE_INFO_ITEM
    }, t), react_1.default.createElement("span", {
      className: e
    }, "/"), react_1.default.createElement("span", {
      className: types_1.Classnames.SLIDE_INFO_ITEM
    }, s)));
  };
exports.SlideInfo = SlideInfo;